export default "__VITE_ASSET__DtQuEREk__"